import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function CardIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 69.89 52.12">
      <rect
        x="1.62"
        y="1.62"
        width="66.64"
        height="48.87"
        rx="4.44"
        ry="4.44"
        fill="none"
        stroke="currentColor"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="1.62"
        y1="14.95"
        x2="68.27"
        y2="14.95"
        stroke="currentColor"
        strokeWidth="3.25"
        strokeLinecap="round"
      />
      <line
        x1="14.95"
        y1="28.28"
        x2="39.39"
        y2="28.28"
        stroke="currentColor"
        strokeWidth="3.25"
        strokeLinecap="round"
      />
      <line
        x1="14.95"
        y1="37.17"
        x2="30.5"
        y2="37.17"
        stroke="currentColor"
        strokeWidth="3.25"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
